export default {
  home: {
    sections: {
      trendingParlays: "Multiple popolari del giorno",
    },
    checkout: {
      placeItOn: "Scommetti su",
    },
    matchups: {
      today: "Matchup di oggi",
      thisWeek: "Matchup di questa settimana",
      upcoming: "Prossimi matchup",
    },
    actions: {
      claimNow: "Richiedi ora",
      showMore: "Mostra di più",
      showLess: "Mostra meno",
    },
    empty: {
      parlayMinGames: "Nessun trend ancora disponibile. Servono almeno 3 partite.",
    },
    hundredPercentClub: {
      subtitle: "Props che hanno centrato il 100% delle partite",
    },
    advancedTools: {
      subtitles: {
        startingLineups: "Trova valore quando cambiano le formazioni iniziali. Incluso con",
        injuryImpact: "Vedi come gli infortuni impattano i compagni. Incluso con",
        opponentRank: "Sfrutta matchup difensivi favorevoli. Incluso con",
        startingPitchers: "Punta spot contro lanciatori vulnerabili. Incluso con",
        weatherReport: "Usa vento e meteo a tuo vantaggio. Incluso con",
      },
    },
    predictionMarkets: {
      status: {
        loading: "Caricamento dei mercati...",
        loadError: "Impossibile caricare i mercati.",
      },
    },
    sidebar: {
      downloadApp: "Scarica l'app",
      neverMissTrend: "Non perdere nessun trend",
      unlockAnalysis: "Sblocca l'analisi completa",
      unlock: "Sblocca",
      mostBetOn: "Più scommessi",
      mostSearched: "Più cercati",
      trendingLeagues: "Campionati popolari",
      topOffers: "Il meglio di {{type}}",
      newsletter: {
        title: "Anticipa i trend",
        description: "Unisciti a <strong>oltre 30.000 scommettitori sportivi</strong> che ricevono analisi e offerte di Linemate nella loro casella di posta.",
        subscribe: "Iscriviti",
        subscribedTitle: "Ora sei iscritto!",
        subscribedBody: "Ti invieremo gli ultimi trend e le offerte di Linemate nella tua casella di posta.",
      },
      improveExperience: "Migliora la tua esperienza Linemate",
      getAccess: "ACCEDI A GIOCATE AVANZATE E INSIGHT PIÙ PROFONDI",
    },
  },
};
